import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-item-carousel-group" }
const _hoisted_2 = {
  key: 0,
  class: "p-item-carousel-group__carousel__wrap"
}
const _hoisted_3 = { class: "p-item-carousel-group__button" }
const _hoisted_4 = {
  key: 1,
  class: "p-item-carousel-group__carousel__wrap"
}
const _hoisted_5 = { class: "p-item-carousel-group__button" }
const _hoisted_6 = {
  key: 2,
  class: "p-item-carousel-group__carousel__wrap"
}
const _hoisted_7 = { class: "p-item-carousel-group__button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemCarousel = _resolveComponent("ItemCarousel")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showHistories)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "p-item-carousel-group__carousel__heading" }, "閲覧履歴", -1)),
          _createVNode(_component_ItemCarousel, {
            "item-list": _ctx.histories,
            "carousel-name": "histories",
            class: "p-item-carousel-group__carousel"
          }, null, 8, ["item-list"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ButtonMain, {
              tag: "a",
              href: "/browser-history/",
              kind: "secondary"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("もっと見る", -1)
              ])),
              _: 1,
              __: [0]
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showRecommendations)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "p-item-carousel-group__carousel__heading" }, "おすすめ", -1)),
          _createVNode(_component_ItemCarousel, {
            "item-list": _ctx.recommendations,
            "carousel-name": "recommendations",
            class: "p-item-carousel-group__carousel"
          }, null, 8, ["item-list"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ButtonMain, {
              tag: "a",
              href: "/product-list/",
              kind: "secondary"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" もっと見る ", -1)
              ])),
              _: 1,
              __: [2]
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFavorites)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "p-item-carousel-group__carousel__heading" }, "お気に入り", -1)),
          _createVNode(_component_ItemCarousel, {
            "item-list": _ctx.favorites,
            "carousel-name": "favorites",
            class: "p-item-carousel-group__carousel"
          }, null, 8, ["item-list"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ButtonMain, {
              tag: "a",
              href: "/favorites",
              kind: "secondary"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("もっと見る", -1)
              ])),
              _: 1,
              __: [4]
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}